import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'

export const useIsStrictBrandControl = (): boolean => {
  const { data: brandPlan } = useCurrentBrandPlan()
  return brandPlan?.brand_kit?.strict_brand_control ?? false
}
